import { useState, useEffect } from "react";
import { useToastPromise } from "../../components/toastPromise";
import { ReservationsController } from "../../controllers/reservationsController";
import "../../assets/css/reservations.css";
import { TableList } from "../../components/tableList";
import { TableName } from "../../constants/tableName";
import { TableListPreview } from "../../components/tableListPreview";

export const AllNormalReservations = () => {
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(false);
  const [reservationsList, setReservationsList] = useState([]);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const handleDeleteSelected = (selectedRows, success) => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        ReservationsController.deleteAll({
          type: TableName.NORMALRESERVATIONS,
          idList: selectedRows,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: success,
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handlePreviewPopupDialogOpen = (timeSlot = null) => {
    setSelectedTimeSlots(timeSlot);
    setIsPreviewOpen(true);
  };
  const handlePreviewClose = () => {
    setIsPreviewOpen(false);
  };
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        ReservationsController.getAll({
          type: TableName.NORMALRESERVATIONS,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setReservationsList(fetchedData);
        return "Reservations details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    getAll();
  }, []);

  return (
    <section id="reservationsList">
      <h4>NORMAL RESERVATIONS LISTS</h4>
      <hr />
      <TableList
        isEditable={false}
        loading={loading}
        list={reservationsList}
        handlePopupDialogOpen={() => {}}
        handlePreviewPopupDialogOpen={handlePreviewPopupDialogOpen}
        deletePromise={(selectedRows, success) => {
          handleDeleteSelected(selectedRows, success);
        }}
      />
      <TableListPreview
        loading={loading}
        isPreviewOpen={isPreviewOpen}
        handlePreviewClose={handlePreviewClose}
        content={[selectedTimeSlots]}
      />
    </section>
  );
};
